"use strict";exports.tBankInternalDomains=["tinkoff.ru","tinkoffinsurance.ru","dolyame.ru","tbank.ru"];
//# sourceMappingURL=index.cjs.js.map
